export default __webpack_public_path__ + "static/media/photo01_sp.e8d27eba.jpg";